<template>
  <div>
    <!-- <swiper class="swiper" ref="swiper" :options="swiperOption">
      <swiper-slide
        class="swiper-items"
        v-for="(item, index) in swiperList"
        :key="index"
      >
        <img :src="item.imgUrl" class="swiper-img" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper> -->
    <!-- <Test></Test> -->
    <div class="BigSwiper" :style="{width:width}">
      <div class="swiper" v-if="showswiper">
        <swiper :options="swiperOption">
          <swiper-slide style="width:1200px" v-for="(item, index) in bannerlist" :key="index">
            <div class="swiper-items">
              <img :src="$url + item.picture" class="swiper-img" />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-next swiper-button-white"
            slot="button-next"
          >
            <img class="jt" src="../assets/right.png" alt="" />
          </div>
          <div
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
          >
            <img class="jt" src="../assets/right.png" alt="" />
          </div>
        </swiper>
      </div>
    </div>

    <div
      class="swiper swiper1"
      v-if="showswiper"
      :style="{ height: height + 'px' }"
    >
      <swiper :options="swiperOptions" :style="{ height: height + 'px' }">
        <swiper-slide v-for="(item, index) in bannerlist" :key="index">
          <div class="swiper-items" :style="{ height: height + 'px' }">
            <img
              :src="$url + item.picture"
              class="swiper-img"
              :style="{ height: height + 'px' }"
            />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-next swiper-button-white" slot="button-next">
          <img class="jt" src="../assets/right.png" alt="" />
        </div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev">
          <img class="jt" src="../assets/right.png" alt="" />
        </div>
      </swiper>
    </div>

    <div class="swiper swipers" v-if="showswiper">
      <swiper :options="swiperOptions">
        <swiper-slide v-for="(item, index) in bannerlist" :key="index">
          <div class="swiper-items">
            <img :src="$url + item.picture" class="swiper-img" />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-next swiper-button-white" slot="button-next">
          <img class="jt" src="../assets/right.png" alt="" />
        </div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev">
          <img class="jt" src="../assets/right.png" alt="" />
        </div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Test from "./test.vue";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
    Test,
  },
  name: "SwiperViews",
  props: {
    bannerlist: Array,
    height: Number,
    showswiper: Boolean,
  },
  data() {
    return {
      width: "",
      // bannerlist: [],
      // height: 0,
      // showswiper: true,
      swiperList: [
        {
          imgUrl: require("@/assets/swiper1.png"),
        },
        {
          imgUrl: require("@/assets/swiper2.png"),
        },
        {
          imgUrl: require("@/assets/swiper3.png"),
        },
        {
          imgUrl: require("@/assets/swiper1.png"),
        },
        {
          imgUrl: require("@/assets/swiper2.png"),
        },
        {
          imgUrl: require("@/assets/test.png"),
        },
      ],

      swiperOption: {
        loop: true,
        autoplay: { disableOnInteraction: false, },
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        autoplay: { disableOnInteraction: false, },
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  mounted() {
    window.onresize = () => {
      this.width = document.body.clientWidth + "px";
    };
  },
  // created(){
    
  //     this.width = document.body.clientWidth + "px";
  //    window.onresize = () => {
  //     this.width = document.body.clientWidth + "px";
  //   };
  // }
};
</script>

<style lang="scss" scoped>
.BigSwiper {
  // width: 100vw;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.swiper {
  height: 522px;
  // width: 1920px;
  width: 130vw;
  margin: 0 auto;
  @media (max-width: 1366px) {
    width: 100%;
    display: none;
  }
  .swiper-items {
    width: 100%;
    height: 522px;
    margin-right: 20px;
  }
}
.swiper1 {
  height: 100% !important;
  display: none;
  @media (min-width: 768px) and (max-width: 1366px) {
    display: block;
    height: 100%;
  }
  .swiper-items {
    width: 100%;
    height: 100%;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .swiper-button-white {
    @media (min-width: 768px) and (max-width: 1366px) {
      // display: none;
    }
  }
}
.swipers {
  height: 100% !important;
  display: none;
  @media (max-width: 768px) {
    display: block;
    height: 100%;
  }
  .swiper-items {
    width: 100%;
    height: 100%;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  // .swiper-button-white {
  //   @media (max-width: 768px) {
  //     display: none;
  //   }
  // }
}

.swiper-button-next {
  right: 31.4vw;
  @media (max-width: 1366px) {
    right: 5vw;
  }
   @media (max-width: 786px) {
    right: 2vw;
    display: none;
  }
  // transform: rotate(90deg);
}

.swiper-button-prev {
  left: 31.4vw;
  transform: rotate(180deg);
  @media (max-width: 1366px) {
    left: 5vw;
  }
  @media (max-width: 786px) {
    left: 2vw;
    display: none;

  }
}
.swiper-img {
  object-fit: contain;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  // font-size: $font-size-huge * 2;
  background-color: #fff;
}
@media (max-width: 768px) {
  .swiper {
    height: 45vw;
    // width: 1920px;
    width: 100%;
    margin: 0 auto;
    @media (max-width: 1366px) {
      display: none;
    }
    .swiper-items {
      width: 100%;
      height: 45vw;
      margin-right: 0px;
    }
  }
  .swipers {
    display: none;
    @media (max-width: 1366px) {
      display: block;
    }
    // .swiper-button-white {
    //   @media (max-width: 1366px) {
    //     display: none;
    //   }
    // }
  }

  // .swiper-button-next {
  //   right: 23.5vw;
  //   @media (max-width: 1200px) {
  //     right: 69.5vh;
  //   }
  //   // transform: rotate(90deg);
  // }

  // .swiper-button-prev {
  //   left: 23.5vw;
  //   transform: rotate(180deg);
  //   @media (max-width: 1200px) {
  //     left: 69.5vh;
  //   }
  // }
  .swiper-img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    // font-size: $font-size-huge * 2;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SwiperViews.vue